/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Focus_Segment_TitleInputs */

const en_export_power_point_focus_segment_title = /** @type {(inputs: Export_Power_Point_Focus_Segment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Focus Segment`)
};

const de_export_power_point_focus_segment_title = /** @type {(inputs: Export_Power_Point_Focus_Segment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokussegment auswählen`)
};

/**
* | output |
* | --- |
* | "Select Focus Segment" |
*
* @param {Export_Power_Point_Focus_Segment_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_focus_segment_title = /** @type {((inputs?: Export_Power_Point_Focus_Segment_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Focus_Segment_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_focus_segment_title(inputs)
	return de_export_power_point_focus_segment_title(inputs)
});